import { createSlice } from '@reduxjs/toolkit';
const emptyFeatureCollection = { type: 'FeatureCollection', features: [] };

const initialState = {
  project: null,
  state: null,
  district: null,
  sub_district: null,
  village: null,
  lat: 22.150535,
  lon: 81.556363,
  zoom: 4,
  crop: null,
  infest: null,
  project_options: [],
  crop_options: [],
  state_options: [],
  infest_options: [],
  district_options: [],
  sub_district_options: [],
  village_options: [],
  sowingDate: null,
  analysis: 'Infestation Comparison (2 weeks)',
  geojsonMainData: emptyFeatureCollection,
  geojsonDataDistrict: emptyFeatureCollection,
  loading: 0,
  error: null,
  lightMode: true,
  expandMapFeature: false,
  activeMapIndex: 1,
};

export const mapSlice = createSlice({
  name: 'maps&options&geojson',
  initialState,
  reducers: {
    addData: (state, action) => {
      state.data.push(action.payload);
    },
    setProject: (state, action) => {
      state.project = action.payload;
    },
    setState: (state, action) => {
      state.state = action.payload;
    },
    setDistrict: (state, action) => {
      state.district = action.payload;
    },
    setSubDistrict: (state, action) => {
      state.sub_district = action.payload;
    },
    setVillages: (state, action) => {
      state.village = action.payload;
    },
    setLatLon: (state, action) => {
      state.lat = action.payload.lat;
      state.lon = action.payload.lon;
    },
    setZoom: (state, action) => {
      state.zoom = action.payload;
    },
    setCrop: (state, action) => {
      state.crop = action.payload;
    },
    setInfest: (state, action) => {
      state.infest = action.payload;
    },
    setProjectOptions: (state, action) => {
      state.project_options = action.payload;
    },
    setCropOptions: (state, action) => {
      state.crop_options = action.payload;
    },
    setStateOptions: (state, action) => {
      state.state_options = action.payload;
    },
    setDistrictOptions: (state, action) => {
      state.district_options = action.payload;
    },
    setInfestOptions: (state, action) => {
      state.infest_options = action.payload;
    },
    setSubDistrictOptions: (state, action) => {
      state.sub_district_options = action.payload;
    },
    setVillagesOptions: (state, action) => {
      state.village_options = action.payload;
    },
    setSowingDate: (state, action) => {
      state.sowingDate = action.payload;
    },
    setAnalysis: (state, action) => {
      state.analysis = action.payload;
    },
    setMode: (state) => {
      state.lightMode = !state.lightMode;
    },
    setExpandMap: (state) => {
      state.expandMapFeature = !state.expandMapFeature;
    },
    setActiveMapIndex: (state, action) => {
      state.activeMapIndex = action.payload;
    },
    clearGeojson: (state) => {
      state.geojsonMainData = emptyFeatureCollection;
      state.geojsonDataDistrict = emptyFeatureCollection;
    },
    setLoading: (state, action) => {
      if (action.payload === true) state.loading += 1;
      if (action.payload === false && state.loading > 0) state.loading -= 1;
    },
    resetFilters: () => initialState,
  },
});

export const {
  addData,
  setProject,
  setState,
  setDistrict,
  setSubDistrict,
  setVillages,
  setLatLon,
  setZoom,
  setCrop,
  setInfest,
  setProjectOptions,
  setCropOptions,
  setStateOptions,
  setInfestOptions,
  setDistrictOptions,
  setSubDistrictOptions,
  setVillagesOptions,
  setSowingDate,
  setAnalysis,
  setMode,
  setExpandMap,
  setActiveMapIndex,
  clearGeojson,
  setLoading,
  resetFilters,
} = mapSlice.actions;

export default mapSlice.reducer;
